import { useAccount, useReadContract } from "wagmi";
import { mainnet } from "viem/chains";
import { contractConfig } from "@config/contractsConfig";

const useWithdrawalManagerPaused = () => {
  const { chainId } = useAccount();
  const isOnMainnet = chainId === mainnet.id;

  const { data, isLoading, isError, refetch } = useReadContract({
    ...contractConfig[mainnet.id].interactionPools.lrtWithdrawalManager,
    functionName: "paused",
    chainId: mainnet.id,
    query: { enabled: isOnMainnet },
  });

  return {
    isPaused: isOnMainnet && Boolean(data),
    isLoading,
    isError,
    refetch,
  };
};

export default useWithdrawalManagerPaused;
